
<table #dataTable class="data-table">
    <tbody>
        <tr>
            <th class="mfp-header position-sticky top-0" *ngFor="let col of VisibleColumns">
                <div class="d-flex justify-content-between">
                    <span *ngIf="!col.IconHeader; else IconHeader" class="align-self-start">{{ col.DisplayName }}</span>
                    <ng-template #IconHeader>
                        <span class="align-self-start" [title]="col.DisplayName">
                            <i [class]="(col.IconHeader.IconSet || 'fa-solid') + ' ' + col.IconHeader.IconName"></i>
                        </span>
                    </ng-template>
                    <div class="align-self-center ms-2" *ngIf="col.EnableSorting !== false">
                        <a (click)="OrderBy(col.SortProperty || col.PropertyName)">
                            <i class="fa-solid"
                               [ngClass]="GetHeaderSortIconClass(col)"></i>
                        </a>
                    </div>
                </div>
            </th>
        </tr>
        <tr *ngFor="let row of Rows; index as i" (click)="Select(i)" [ngClass]="{ 'selected': IsSelected(i) }">
            <td data-table-cell *ngFor="let col of VisibleColumns" [content]="(col.Formatter || DefaultFormatter)(ExtractProperty(row, col.PropertyName), row)">
            </td>
        </tr>
    </tbody>
</table>